import { ChangeEvent } from "react"
import styled from "styled-components"

import { useLazyGetContractorsQuery } from "store/api/contractorsApi"
import styles from "assets/scss/index.module.scss"

import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"
import { InputNew } from "components/form/InputNew"
import { SelectDynamic } from "components/form/SelectDynamic"
import { Textarea } from "components/form/Textarea"

import { AssignmentValues, SectionTitle } from "./formValues"

const SelectField = styled.div`
  margin-bottom: 16px;
`

interface Props {
  values: AssignmentValues
  setValues: React.Dispatch<React.SetStateAction<AssignmentValues>>
}

export const AssignmentSection = ({ values, setValues }: Props) => {
  const onSerialNumberChange = (index: number) => (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget
    setValues(prevState => ({
      ...prevState,
      serialNumbers: prevState.serialNumbers.map((serial, i) => (i === index ? value : serial)),
    }))
  }

  return (
    <>
      <SectionTitle>
        <ModalSectionTitle title="Assignment" />
      </SectionTitle>
      <InputNew
        label="CSM"
        placeholder="Enter name"
        name="csm_name"
        value={values.csmName}
        onChange={event => {
          const { value } = event.currentTarget
          setValues(prevState => ({ ...prevState, csmName: value }))
        }}
      />
      <SelectField>
        <SelectDynamic
          label="Contractor"
          placeholder="Search to select"
          name="contractor"
          valueName="id"
          labelName="name"
          values={values.contractor}
          useLazyQuery={useLazyGetContractorsQuery}
          onChange={contractor => setValues(prevState => ({ ...prevState, contractor }))}
        />
      </SelectField>
      <div className={styles.fieldLabelNew}>Internal note</div>
      <Textarea
        skipLabel
        placeholder="Add a note visible only to the Nuve team..."
        name="internal_note"
        rows={4}
        value={values.internalNote}
        onChange={event => {
          const { value } = event.currentTarget
          setValues(prevState => ({ ...prevState, internalNote: value }))
        }}
      />
      {values.serialNumbers.map((serial, index) => (
        <InputNew
          key={index}
          label={values.serialNumbers.length > 1 ? `Thermostat ${index + 1} SN (Optional)` : "Thermostat SN (Optional)"}
          placeholder="Enter SN"
          name={`thermostat_sn_${index}`}
          value={serial}
          onChange={onSerialNumberChange(index)}
        />
      ))}
    </>
  )
}
